import { Component, OnInit, ViewChild } from "@angular/core";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { ChannelProvider } from "../../shared/providers/channel.provider";
import { GeographyProvider } from "../../shared/providers/geography.provider";
import { RegionProvider } from "../../shared/providers/region.provider";
import { RegionModel } from "../../shared/models/region";
import { ExcelModel, GeographyModel } from "../../shared/models/geography";
import { ChannelModel } from "../../shared/models/channel";
import { RolesProvider } from "../../shared/providers/roles.provider";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { StateProvider } from "../../shared/providers/state.provider";
import { TabDirective, TabsetComponent } from "ngx-bootstrap/tabs";
import {
  UpdateMobileModel,
  UserDetailModel,
  UserMobileUpdateModel,
} from "../../shared/models/User";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
  @ViewChild(TabsetComponent, { static: false }) tabset: TabsetComponent;
  page = 1;
  secondTabPage = 1;
  thirdTabPage = 1;
  FourthTabPage = 1;
  FivthTabPage = 1;
  SixthTabPage = 1;
  SeventhTabPage = 1;
  EighthTabPage = 1;
  users: UserDetailModel[];
  secondTabUsers = [];
  thirdTabUsers = [];
  fourthTabUsers = [];
  fivthTabUsers = [];
  sixthTabUsers = [];
  seventhTabUsers = [];
  eigthTabUsers = [];
  getPaginationCount;
  secondTabgetPaginationCount = 1;
  thirdTabgetPaginationCount = 1;
  fourthTabgetPaginationCount = 1;
  fivthTabgetPaginationCount = 1;
  sixthTabgetPaginationCount = 1;
  sevenTabgetPaginationCount = 1;
  eigthTabgetPaginationCount = 1;
  regions: RegionModel[];
  geography: GeographyModel[];
  channels: ChannelModel[];
  roles: any[];
  cities: any[];
  states: any[];
  tempOptionModel: any;
  excel: ExcelModel = new ExcelModel();
  filteredDetails: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails2: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails3: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails4: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails5: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails6: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails7: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  filteredDetails8: any = {
    search_string: "",
    regions: [],
    user_roles: [],
    geography: [],
    states: [],
    city: [],
  };

  // 1 TAB
  filteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  // 2 TAB

  secondfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  // 3 TAB

  thirdfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  // 4 TAB

  fourthfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  fivthfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  sixthfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  sevenfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  eightfilteredDetailsForApi: any = {
    search_string: "",
    regions: "",
    user_roles: "",
    geography: "",
    states: "",
    city: "",
  };

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    public regionProviders: RegionProvider,
    public stateProviders: StateProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private rolesProvider: RolesProvider,
    public toast: ToastClientService,
    private xlsx: XlsxService,
    public alertService: AlertService,
    private uploadFile: UploadZipService
  ) {
    this.uploadFile.currentMessage.subscribe((message) => {
      if (message.status == "success") {
        this.getActiveTab();
      }
    });
  }

  ngOnInit() {
    this.getAllUsers(this.page, 5, this.filteredDetailsForApi);
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.channels = this.channelProviders.channels;
    this.geography = this.geoProviders.geography;
    this.roles = this.rolesProvider.roles;
    this.states = this.stateProviders.state;
  }
  formateStates(states) {
    let filteredStates: any[] = states.filter(
      (ele) => (ele.id = ele.state_code)
    );
    if (filteredStates.length > 0) {
      filteredStates.forEach((ele) => {
        ele.stateName = ele.state_name + " - " + ele.state_year;
      });
    }
    this.states = filteredStates;
  }

  addUser() {
    this.router.navigateByUrl("/hubAdmin/create-user");
  }

  paginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 5, this.filteredDetailsForApi);
    this.page = pageNumber;
  }

  secondTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 6, this.secondfilteredDetailsForApi);
    this.secondTabPage = pageNumber;
  }

  thirdTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 4, this.thirdfilteredDetailsForApi);
    this.thirdTabPage = pageNumber;
  }

  fourthTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 7, this.fourthfilteredDetailsForApi);
    this.FourthTabPage = pageNumber;
  }

  fivthTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 4, this.fivthfilteredDetailsForApi);
    this.FivthTabPage = pageNumber;
  }

  sixthTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 15, this.sixthfilteredDetailsForApi);
    this.SixthTabPage = pageNumber;
  }

  seventhTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 14, this.sevenfilteredDetailsForApi);
    this.SixthTabPage = pageNumber;
  }

  eigthTabpaginationClick(pageNumber) {
    this.getAllUsers(pageNumber, 14, this.sevenfilteredDetailsForApi);
    this.SixthTabPage = pageNumber;
  }

  downloadExcel() {
    this.exportExcelService.exportUserPhoneUpdate();
  }

  excelFileName: string;

  /**
   * @auth kailash_dev
   */
  /** Add new brands section */
  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  uploadXlsx(eve) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          let updateData: UpdateMobileModel = new UpdateMobileModel();
          updateData.userexcelupload = 1;
          updateData.userupdate = this.excel.excel_data;
          this.enableUploadDiv(updateData);
        }
      },
      (reason) => { }
    );
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.UpdateUserMobile,
      module: "Users",
      zip: "no",
      excelname: this.excelFileName,
    });
  }

  importAllUsers(data) {
    this.apiService.post(this.apiConfig.importExcelUser, data).subscribe(
      (res: any) => {
        this.toast.Success("Data imported Successfully");
        this.getActiveTab();
      },
      (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      }
    );
  }

  StatesfilterByRegion: any[];
  StatesfilterByRegion2: any[];
  StatesfilterByRegion3: any[];
  StatesfilterByRegion4: any[];
  StatesfilterByRegion5: any[];
  StatesfilterByRegion6: any[];
  StatesfilterByRegion7: any[];
  StatesfilterByRegion8: any[];

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails.states = await data;
        break;
      case 3: // city
        this.filteredDetails.city = await data;
        break;
      case 4: // resions
        this.filteredDetails.regions = await data;
        this.StatesfilterByRegion = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion.push(
            ...this.states.filter(
              (s) => s.region_id == element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails.geography = await data;
        break;
      default:
        break;
    }
  }

  // 2nd Tab

  async selectedItem2(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails2.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails2.states = await data;
        break;
      case 3: // city
        this.filteredDetails2.city = await data;
        break;
      case 4: // resions
        this.filteredDetails2.regions = await data;
        this.StatesfilterByRegion2 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion2.push(
            ...this.states.filter(
              (s) => s.region_id == element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails2.geography = await data;
        break;
      default:
        break;
    }
  }

  // 3rd Tab

  async selectedItem3(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails3.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails3.states = await data;
        break;
      case 3: // city
        this.filteredDetails3.city = await data;
        break;
      case 4: // resions
        this.filteredDetails3.regions = await data;
        this.StatesfilterByRegion3 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion3.push(
            ...this.states.filter(
              (s) => s.region_id != element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails3.geography = await data;
        break;
      default:
        break;
    }
  }

  // 4th Tab

  async selectedItem4(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails4.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails4.states = await data;
        break;
      case 3: // city
        this.filteredDetails4.city = await data;
        break;
      case 4: // resions
        this.filteredDetails4.regions = await data;
        this.StatesfilterByRegion4 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion4.push(
            ...this.states.filter(
              (s) => s.region_id != element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails4.geography = await data;
        break;
      default:
        break;
    }
  }

  //5th Tab

  async selectedItem5(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails5.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails5.states = await data;
        break;
      case 3: // city
        this.filteredDetails5.city = await data;
        break;
      case 4: // resions
        this.filteredDetails5.regions = await data;
        this.StatesfilterByRegion5 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion5.push(
            ...this.states.filter(
              (s) => s.region_id != element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails5.geography = await data;
        break;
      default:
        break;
    }
  }

  //6th Tab

  async selectedItem6(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails6.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails6.states = await data;
        break;
      case 3: // city
        this.filteredDetails6.city = await data;
        break;
      case 4: // resions
        this.filteredDetails6.regions = await data;
        this.StatesfilterByRegion6 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion6.push(
            ...this.states.filter(
              (s) => s.region_id != element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails6.geography = await data;
        break;
      default:
        break;
    }
  }

  //7th Tab

  async selectedItem7(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails7.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails7.states = await data;
        break;
      case 3: // city
        this.filteredDetails7.city = await data;
        break;
      case 4: // resions
        this.filteredDetails7.regions = await data;
        this.StatesfilterByRegion7 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion7.push(
            ...this.states.filter(
              (s) => s.region_id != element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails7.geography = await data;
        break;
      default:
        break;
    }
  }

  //8th Tab

  async selectedItem8(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails8.user_roles = await data;
        break;
      case 2: // State
        this.filteredDetails8.states = await data;
        break;
      case 3: // city
        this.filteredDetails8.city = await data;
        break;
      case 4: // resions
        this.filteredDetails8.regions = await data;
        this.StatesfilterByRegion8 = [];
        let item = data;
        item.forEach((element) => {
          this.StatesfilterByRegion8.push(
            ...this.states.filter(
              (s) => s.region_id != element.id && s.state_year == 2021
            )
          );
        });
        break;
      case 5: // geography
        this.filteredDetails8.geography = await data;
        break;
      default:
        break;
    }
  }

  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.city = this.filteredDetails.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.geography = this.filteredDetails.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.user_roles = this.filteredDetails.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
      this.getActiveTab();
    } catch (error) { }
  }

  filterListOfRecords2() {
    try {
      this.secondfilteredDetailsForApi.states = this.filteredDetails2.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.secondfilteredDetailsForApi.city = this.filteredDetails2.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.secondfilteredDetailsForApi.regions = this.filteredDetails2.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.secondfilteredDetailsForApi.geography = this.filteredDetails2.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.secondfilteredDetailsForApi.user_roles = this.filteredDetails2.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.secondfilteredDetailsForApi.search_string = this.filteredDetails2.search_string;
      this.getActiveTab();
    } catch (error) { }
  }

  filterListOfRecords3() {
    try {
      this.thirdfilteredDetailsForApi.states = this.filteredDetails3.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.thirdfilteredDetailsForApi.city = this.filteredDetails3.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.thirdfilteredDetailsForApi.regions = this.filteredDetails3.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.thirdfilteredDetailsForApi.geography = this.filteredDetails3.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.thirdfilteredDetailsForApi.user_roles = this.filteredDetails3.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.thirdfilteredDetailsForApi.search_string = this.filteredDetails3.search_string;
    } catch (error) { }
  }

  filterListOfRecords4() {
    try {
      this.fourthfilteredDetailsForApi.states = this.filteredDetails4.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fourthfilteredDetailsForApi.city = this.filteredDetails4.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fourthfilteredDetailsForApi.regions = this.filteredDetails4.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fourthfilteredDetailsForApi.geography = this.filteredDetails4.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fourthfilteredDetailsForApi.user_roles = this.filteredDetails4.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fourthfilteredDetailsForApi.search_string = this.filteredDetails4.search_string;
    } catch (error) { }
  }

  filterListOfRecords5() {
    try {
      this.fivthfilteredDetailsForApi.states = this.filteredDetails5.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fivthfilteredDetailsForApi.city = this.filteredDetails5.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fivthfilteredDetailsForApi.regions = this.filteredDetails5.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fivthfilteredDetailsForApi.geography = this.filteredDetails5.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fivthfilteredDetailsForApi.user_roles = this.filteredDetails5.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.fivthfilteredDetailsForApi.search_string = this.filteredDetails5.search_string;
    } catch (error) { }
  }

  filterListOfRecords6() {
    try {
      this.sixthfilteredDetailsForApi.states = this.filteredDetails6.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sixthfilteredDetailsForApi.city = this.filteredDetails6.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sixthfilteredDetailsForApi.regions = this.filteredDetails6.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sixthfilteredDetailsForApi.geography = this.filteredDetails6.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sixthfilteredDetailsForApi.user_roles = this.filteredDetails6.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sixthfilteredDetailsForApi.search_string = this.filteredDetails6.search_string;
    } catch (error) { }
  }

  filterListOfRecords7() {
    try {
      this.sevenfilteredDetailsForApi.states = this.filteredDetails7.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sevenfilteredDetailsForApi.city = this.filteredDetails7.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sevenfilteredDetailsForApi.regions = this.filteredDetails7.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sevenfilteredDetailsForApi.geography = this.filteredDetails7.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sevenfilteredDetailsForApi.user_roles = this.filteredDetails7.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.sevenfilteredDetailsForApi.search_string = this.filteredDetails7.search_string;
    } catch (error) { }
  }

  filterListOfRecords8() {
    try {
      this.eightfilteredDetailsForApi.states = this.filteredDetails8.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.eightfilteredDetailsForApi.city = this.filteredDetails8.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.eightfilteredDetailsForApi.regions = this.filteredDetails8.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.eightfilteredDetailsForApi.geography = this.filteredDetails8.geography
        .map((i) => i.id)
        .join(",")
        .toString();
      this.eightfilteredDetailsForApi.user_roles = this.filteredDetails8.user_roles
        .map((i) => i.id)
        .join(",")
        .toString();
      this.eightfilteredDetailsForApi.search_string = this.filteredDetails8.search_string;
    } catch (error) { }
  }
  value: string;
  onSelect(data: TabDirective): void {
    this.value = data.heading;
    switch (this.value) {
      case "Outlet Manager":
        this.getAllUsers(this.page, 5, this.filteredDetailsForApi);
        break;
      case "Waiter":
        this.getAllUsers(
          this.secondTabPage,
          6,
          this.secondfilteredDetailsForApi
        );
        break;
      case "Territory Sales Executive":
        this.getAllUsers(this.thirdTabPage, 4, this.thirdfilteredDetailsForApi);
        break;
      case "Mystery Shopper":
        this.getAllUsers(
          this.FourthTabPage,
          7,
          this.fourthfilteredDetailsForApi
        );
        break;
      case "M1":
        this.getAllUsers(
          this.FivthTabPage,
          4,
          this.fivthfilteredDetailsForApi
        );
        break;
      case "M2":
        this.getAllUsers(
          this.SixthTabPage,
          15,
          this.sixthfilteredDetailsForApi
        );
        break;
      case "M3":
        this.getAllUsers(
          this.SeventhTabPage,
          14,
          this.sevenfilteredDetailsForApi
        );
        break;
      case "TMM":
        this.getAllUsers(
          this.EighthTabPage,
          20,
          this.eightfilteredDetailsForApi
        );
        break;
      default:
        break;
    }
  }

  getActiveTab() {
    const activeTab = this.tabset.tabs.filter((tab) => tab.active);
    let heading = activeTab[0].heading;
    switch (heading) {
      case "Outlet Manager":
        this.getAllUsers(this.page, 5, this.filteredDetailsForApi);
        break;
      case "Waiter":
        this.getAllUsers(
          this.secondTabPage,
          6,
          this.secondfilteredDetailsForApi
        );
        break;
      case "Territory Sales Executive":
        this.getAllUsers(this.thirdTabPage, 4, this.thirdfilteredDetailsForApi);
        break;
      case "Mystery Shopper":
        this.getAllUsers(
          this.FourthTabPage,
          7,
          this.fourthfilteredDetailsForApi
        );
        break;
      case "M1":
        this.getAllUsers(
          this.FivthTabPage,
          4,
          this.fourthfilteredDetailsForApi
        );
        break;
      case "M2":
        this.getAllUsers(
          this.SixthTabPage,
          15,
          this.sixthfilteredDetailsForApi
        );
        break;
      case "M3":
        this.getAllUsers(
          this.SeventhTabPage,
          14,
          this.sevenfilteredDetailsForApi
        );
        break;
      case "TMM":
        this.getAllUsers(
          this.EighthTabPage,
          14,
          this.eightfilteredDetailsForApi
        );
        break;
      default:
        break;
    }
  }

  getAllUsers(pageNumber, role, data) {
    this.apiService
      .getHeaders(
        this.apiConfig.allUsers +
        "?page=" +
        pageNumber +
        "&search_string=" +
        data.search_string +
        "&geographical_id=" +
        data.geography +
        "&user_role_id=" +
        role +
        "&state_code=" +
        data.states +
        "&region_id=" +
        data.regions +
        "&city=" +
        data.city
      )
      .subscribe(
        (res: any) => {
          switch (role) {
            case 5:
              this.getPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.users = res.body.data;
              if (this.users.length > 0) {
                this.users.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
            case 6:
              this.secondTabgetPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.secondTabUsers = res.body.data;
              if (this.secondTabUsers.length > 0) {
                this.secondTabUsers.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
            case 4:
              this.thirdTabgetPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.thirdTabUsers = res.body.data;
              this.thirdTabUsers = res.body.data;
              if (this.thirdTabUsers.length > 0) {
                this.thirdTabUsers.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
            case 7:
              this.fourthTabgetPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.fourthTabUsers = res.body.data;
              if (this.fourthTabUsers.length > 0) {
                this.fourthTabUsers.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
            case 15:
              this.sixthTabgetPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.sixthTabUsers = res.body.data;
              if (this.sixthTabUsers.length > 0) {
                this.sixthTabUsers.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
            case 14:
              this.sevenTabgetPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.seventhTabUsers = res.body.data;
              if (this.seventhTabUsers.length > 0) {
                this.seventhTabUsers.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
            case 20:
              this.eigthTabgetPaginationCount = res.headers.get(
                "X-Pagination-Total-Count"
              );
              this.eigthTabUsers = res.body.data;
              if (this.eigthTabUsers.length > 0) {
                this.eigthTabUsers.forEach((i) => {
                  i.isEdit = false;
                });
              }
              break;
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  editRowUser(index, item: UserDetailModel) {
    item.isEdit = true;
    console.log(item);
  }

  userMobile: UserMobileUpdateModel[] = [];

  updateDataUser(index, item: UserDetailModel, type) {
    this.userMobile = [];
    item.isEdit = false;
    let data: UserMobileUpdateModel = new UserMobileUpdateModel();
    data.mobile = item.username;
    data.user_id = item.user_id;
    this.userMobile.push(data);
    let updateData: UpdateMobileModel = new UpdateMobileModel();
    updateData.userexcelupload = 0;
    updateData.userupdate = this.userMobile;
    this.updateUserMobileNumber(updateData, type, index);
  }

  updateUserMobileNumber(item: UpdateMobileModel, type, index) {
    this.apiService.post(this.apiConfig.UpdateUserMobile, item).subscribe(
      (res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success("Updated successfully");
            this.alertService.success(res.body.data.message);
            this.clearSuccess();
          }
        }
      },
      (err) => {
        console.log(err);
        this.getActiveTab();
      }
    );
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
